<!-- Desktop Version -->
<div
  class="container search-pagination-desktop-container d-none d-md-block"
  *ngIf="searchResult.searchResultList?.length && showPagination"
>
  <div class="row">
    <div class="col text-center">
      <!-- Navigate Left -->
      <a
        *ngIf="showNavigateLeft()"
        (click)="navigate('left')"
        class="search-pagination-desktop-navigate-left"
      >
        <svg-icon key="nav-left" width="25px" height="25px"></svg-icon>
      </a>

      <!-- Navigation Links -->
      <span>
        <ng-container *ngFor="let item of navigationItems">
          <span
            *ngIf="item.isSelected"
            class="search-pagination-desktop-item search-pagination-desktop-active"
            >{{ item.value < 10 ? "0" + item.value : item.value }}</span
          >
          <span
            *ngIf="!item.isSelected"
            class="search-pagination-desktop-item search-pagination-desktop-inactive"
            ><a (click)="navigate(item.value)">{{
              item.value < 10 ? "0" + item.value : item.value
            }}</a></span
          >
        </ng-container>
      </span>

      <!-- Navigate Right -->
      <a
        *ngIf="showNavigateRight()"
        (click)="navigate('right')"
        class="search-pagination-desktop-navigate-right"
      >
        <svg-icon key="nav-right" width="28px" height="24px"></svg-icon>
      </a>
    </div>
  </div>
</div>

<!-- Mobile Version -->
<div class="container g-0 d-md-none">
  <div
    class="d-flex justify-content-between search-pagination-mobile-row"
    *ngIf="searchResult.searchResultList?.length && showPagination"
  >
    <!-- Results Info -->
    <div>
      <span
        translate="searchResultsInfoString"
        [translateParams]="{ '0': interval, '1': totalResults }"
        class="search-pagination-mobile-results-info"
      ></span>
    </div>

    <!-- Pagination -->
    <div
      class="d-flex justify-content-end align-items-baseline"
      *ngIf="searchResult.searchResultList?.length && totalPages > 1"
    >
      <!-- Navigate Left -->
      <a
        *ngIf="showNavigateLeft()"
        (click)="navigate('left')"
        class="search-pagination-mobile-navigate-left"
      >
        <svg-icon key="nav-left-mobile" width="9px" height="12px"></svg-icon>
      </a>
      <span
        *ngIf="!showNavigateLeft()"
        class="search-pagination-mobile-navigate-left"
      >
        <svg-icon
          key="nav-left-mobile-inactive"
          width="9px"
          height="12px"
        ></svg-icon>
      </span>

      <!-- Current Page -->
      <span class="search-pagination-mobile-current-page">{{
        actualPage
      }}</span>

      <!-- Navigate Right -->
      <a
        *ngIf="showNavigateRight()"
        (click)="navigate('right')"
        class="search-pagination-mobile-navigate-right"
      >
        <svg-icon key="nav-right-mobile" width="8px" height="12px"></svg-icon>
      </a>
      <span
        *ngIf="!showNavigateRight()"
        class="search-pagination-mobile-navigate-right"
      >
        <svg-icon
          key="nav-right-mobile-inactive"
          width="8px"
          height="12px"
        ></svg-icon>
      </span>

      <!-- Total Pages -->
      <span
        class="search-pagination-mobile-total-pages"
        translate="searchResultsPaginationInfoString"
        [translateParams]="{ '0': totalPages }"
      ></span>
    </div>
  </div>
</div>
<div class="container separator" *ngIf="!showPagination"></div>
